import Ajax from "Utils/ajax";
export const getAllStaffByHRorManager = (data) => Ajax.post('hr/getAllStaffByHRorManager',data);
export const updateSeparationForm = (data) => Ajax.post('hr/updateSeparationForm',data);
export const separationList = (data) => Ajax.post('hr/separationList',data);